import { ISignInRule, SectionType, TaskConfig } from '@/views/bot/types';

export const BOT_PERMISSION_TYPES = {
  room: 1,
  user: 2,
  role: 3,
  channel: 4,
};

export const BOT_COMMAND_OPTION_TYPES = {
  subCommand: 1,
  subCommandGroup: 2,
  string: 3,
  integer: 4,
  boolean: 5,
  user: 6,
  channel: 7,
  role: 8,
  img: 11,
  file: 12,
  fightCard: 13, // 开黑卡片
};

export const BOT_COMMAND_OPTION_TYPES_NEED_UPLOAD = [
  BOT_COMMAND_OPTION_TYPES.img,
  BOT_COMMAND_OPTION_TYPES.file,
];

export const BOT_TYPES = {
  official: -1, // 内置命令
  recent: -999, // 最近使用
};

export const USER_APPLY_TYPE = [
  '',
  'developer/auth_form?type=individual', // type===1为个人认证
  'developer/auth_form?type=company', // type===2为企业认证
  'developer/auth_form?type=oversea', // type===3为海外认证
  'chat_robot/auth/form?type=chat_individual', // type===4为语音个人认证
  'chat_robot/auth/form?type=chat_company', // type===5为语音企业认证
];

export const DEFAULT_KEY = 'value';

export enum TaskType {
  Chat = 1, // 单次语音时长
  Message = 2, // 发送文字
  Invite = 3, // 邀请好友
  Client = 4, // 使用PC客户端
  ReplyEmoji = 6, // 回复表情
  SendImg = 7, // 发送图片
  CumulativelyChat = 8, // 累计语音时长
}

// 表情回复类型
export enum EmojiReplyType {
  Current = '1', // 回复当前消息
  Specific = '2', // 回复指定消息
}

/**
 * 抽奖方式
 * @deprecated 使用 NewLotteryType 代替
 */
export const LotteryType = {
  Auto: false, // 自动抽奖
  Manual: true, // 手动抽奖
};

/**
 *
 */
export enum NewLotteryType {
  Auto = 1, // 自动抽奖
  Manual, // 手动抽奖
  Points, // 积分抽奖
}

export const LOTTERY_TASK_OPTION = [
  {
    type: TaskType.Invite,
    text: '邀请好友',
  },
  {
    type: TaskType.Message,
    text: '发送文字',
  },
  {
    type: TaskType.Chat,
    text: '频道内单次语音',
  },
  {
    type: TaskType.Client,
    text: '使用PC客户端',
  },
  {
    type: TaskType.ReplyEmoji,
    text: '回复表情',
  },
  {
    type: TaskType.SendImg,
    text: '发送图片',
  },
  {
    type: TaskType.CumulativelyChat,
    text: '频道内累计语音',
  },
];

export const LOTTERY_TASK_TEMPLATE = {
  [TaskType.Invite]: '邀请x名好友进入房间',
  [TaskType.Message]: '在xx频道内发送yy',
  [TaskType.Chat]: 'x人频道内语音y分钟',
  [TaskType.Client]: '使用黑盒语音PC客户端参与抽奖',
  [TaskType.ReplyEmoji]: '回复xx消息表情',
  [TaskType.SendImg]: '在xx频道内发送图片',
  [TaskType.CumulativelyChat]: 'x人频道内累计开麦语音y分钟',
};

export const REPLY_EMOJI_OPTION = [
  {
    type: EmojiReplyType.Current,
    text: '回复本条抽奖消息',
  },
  {
    type: EmojiReplyType.Specific,
    text: '回复指定消息',
  },
];

// 抽奖方式选项
export const LOTTERY_TYPE_OPTIONS = [
  {
    value: NewLotteryType.Auto,
    label: '自动抽奖',
    disabled: (list: TaskConfig[] | null) => {
      const res = list?.some((item) => item.task_type === TaskType.SendImg);
      return res;
    },
  },
  {
    value: NewLotteryType.Manual,
    label: '手动抽奖',
  },
  {
    value: NewLotteryType.Points,
    label: '积分抽奖',
  },
];

// 签到规则类型
export const SIGN_IN_RULE_TYPE_VALUE = {
  CONTINUOUS: 0,
  CUMULATIVE: 1,
};

// 兑换模版字符串
export const EXCHANGE_ITEM_STR_MAP = {
  CDK: '{奖品CDK}',
  NAME: '{奖品名称}',
  POINTS: '{兑换积分}',
  POINTS_NAME: '{积分}',
};

// 兑换默认私聊通知模版
export const EXCHANGE_DEFAULT_MSG_TEMPLATE_MAP = {
  CDK: `已成功兑换 ${EXCHANGE_ITEM_STR_MAP.NAME}，CDK为 ${EXCHANGE_ITEM_STR_MAP.CDK}，消耗${EXCHANGE_ITEM_STR_MAP.POINTS_NAME} ${EXCHANGE_ITEM_STR_MAP.POINTS}`,
  PHYSICAL: `已成功兑换 ${EXCHANGE_ITEM_STR_MAP.NAME}，消耗${EXCHANGE_ITEM_STR_MAP.POINTS_NAME} ${EXCHANGE_ITEM_STR_MAP.POINTS}`,
};

// 兑换奖品类型
export const EXCHANGE_AWARD_TYPE = {
  CDK: 0,
  PHYSICAL: 1,
  OFFICIAL: 2,
};

// 默认抽奖任务名称
export const DEFAULT_LOTTERY_TASK_NAME = {
  [TaskType.Invite]: '邀请x名好友进入房间',
  [TaskType.Message]: '在xx频道内发送yy',
  [TaskType.Chat]: 'x人频道内单次开麦语音y分钟',
  [TaskType.Client]: '使用黑盒语音PC客户端参与抽奖',
  [TaskType.ReplyEmoji]: '回复xx消息表情',
  [TaskType.SendImg]: '在xx频道内发送图片',
  [TaskType.CumulativelyChat]: 'x人频道内累计开麦语音y分钟（至少z天语音）',
};

export const LOTTERY_SITUATION_BUTTON_CONFIGS = [
  {
    type: SectionType.ParticipantList,
    text: '参与用户',
  },
  {
    type: SectionType.WinningList,
    text: '中奖用户',
  },
];

// 默认签到奖励积分
export const DEFAULT_SIGN_IN_POINTS = 1;

// 语音打卡类型
export const AUDIO_SIGN_IN_TYPE = {
  SINGLE: '1', // 每日单次
  MULTIPLE: '2', // 每日多次
};

// 语音打卡时长
export const DEFAULT_SIGN_IN_AUDIO_DURATION = '1';

// 语音打卡积分
export const DEFAULT_SIGN_IN_AUDIO_POINTS = '1';

// 聊天打卡积分
export const DEFAULT_SIGN_IN_CHAT_POINTS = '1';

// 获取默认的签到规则
export const getDefaultSignInRule = (): ISignInRule => {
  return {
    custom_points_name: '',
    base_check_in: {
      is_open: false,
      channel_id: '',
      base_points: DEFAULT_SIGN_IN_POINTS,
      rules: [],
    },
    audio_check_in: {
      is_open: false, // 是否开启
      type: AUDIO_SIGN_IN_TYPE.SINGLE, // 1: 每日单次 2: 累计时长
      duration: DEFAULT_SIGN_IN_AUDIO_DURATION, // 时长
      points: DEFAULT_SIGN_IN_AUDIO_POINTS, // 积分
      appid: NO_GAME_OPTION, // 游戏appid
    },
    chat_check_in: {
      is_open: false, // 是否开启
      channel_ids: [], // 文字频道id数组， 全选[-1],
      points: DEFAULT_SIGN_IN_CHAT_POINTS, // 积分
    },
  };
};

// 兑换时间选项
export const EXCHANGE_FREQUENCY_OPTIONS = [
  {
    value: 0,
    label: '不限时可兑换【限购数量】次',
  },
  {
    value: 1,
    label: '每自然周可兑换【限购数量】次',
  },
  {
    value: 2,
    label: '每自然月可兑换 【限购数量】次',
  },
];

// 官方奖励类型
export enum EXCHANGE_OFFICIAL_PRIZE_TYPES {
  SCREENSHARE = 0, // 屏幕共享
  AVATAR_DECORATION = 1, // 头像框
  CARD = 2, // 资料卡
  ACCELERATOR = 3, // 加速器
}

// 官方奖励时长
export enum EXCHANGE_OFFICIAL_PRIZE_DURATION {
  DAY = 0, // 1天
  WEEK = 1, // 1周
  MONTH = 2, // 1个月
  THREE_MONTHS = 3, // 3个月
  HALF_YEAR = 4, // 半年
  YEAR = 5, // 一年
}

// 官方奖励时长选项
export const EXCHANGE_OFFICIAL_PRIZE_DURATION_OPTIONS = [
  {
    value: EXCHANGE_OFFICIAL_PRIZE_DURATION.DAY,
    label: '1天',
  },
  {
    value: EXCHANGE_OFFICIAL_PRIZE_DURATION.WEEK,
    label: '1周',
  },
  {
    value: EXCHANGE_OFFICIAL_PRIZE_DURATION.MONTH,
    label: '1个月',
  },
  {
    value: EXCHANGE_OFFICIAL_PRIZE_DURATION.THREE_MONTHS,
    label: '3个月',
  },
  {
    value: EXCHANGE_OFFICIAL_PRIZE_DURATION.HALF_YEAR,
    label: '半年',
  },
  {
    value: EXCHANGE_OFFICIAL_PRIZE_DURATION.YEAR,
    label: '1年',
  },
];

// 官方奖励类型选项
export const EXCHANGE_OFFICIAL_PRIZE_TYPES_OPTIONS = [
  {
    value: EXCHANGE_OFFICIAL_PRIZE_TYPES.SCREENSHARE,
    label: '屏幕共享',
  },
  {
    value: EXCHANGE_OFFICIAL_PRIZE_TYPES.AVATAR_DECORATION,
    label: '头像框',
  },
  {
    value: EXCHANGE_OFFICIAL_PRIZE_TYPES.CARD,
    label: '资料卡',
  },
  {
    value: EXCHANGE_OFFICIAL_PRIZE_TYPES.ACCELERATOR,
    label: '加速器',
  },
];

// 屏幕共享时长卡类型
export enum SCREENSHARE_TYPE {
  SCREENSHARE_720 = 1, // 720p
  SCREENSHARE_1080 = 2, // 1080p
}

// 屏幕共享时长卡选项
export const SCREENSHARE_TYPE_OPTIONS = [
  {
    value: SCREENSHARE_TYPE.SCREENSHARE_720,
    label: '720p',
  },
  {
    value: SCREENSHARE_TYPE.SCREENSHARE_1080,
    label: '1080p',
  },
];

// 无制定游戏常量
export const NO_GAME_OPTION = '0';

// 奖品分配方式
export enum PrizeAllocationType {
  NoAverage = 1, // 无平均分配
  DailyAverage = 2, // 每日分配
  MinuteAverage = 3, // 分钟分配
}

// 奖品分配方式选项
export const PRIZE_ALLOCATION_OPTIONS = [
  {
    value: PrizeAllocationType.NoAverage,
    label: '无均分',
  },
  {
    value: PrizeAllocationType.DailyAverage,
    label: '每天上限',
    tooltipText: '奖品总数平均分配至每日，举例计划发奖品100个，活动进行10天，则每日最多发放10个'
  },
  {
    value: PrizeAllocationType.MinuteAverage,
    label: '按分钟均分',
    tooltipText: '每分钟自动解锁（可以被抽到）一定量的奖品'
  },
];